import React, { forwardRef, useEffect, useRef,useImperativeHandle } from "react";
import * as d3 from 'd3';
import useEditorStore from "@/store/useEditorStore";
import { D3Line } from "./D3Line";



const LinkLayer = forwardRef(({width, height},ref) => {
    const links = useEditorStore.use.links();
    const new_link = useEditorStore.use.new_link();
    useEffect(() => {
        if (ref.current) {
            const linkLayer = d3.select(ref.current);
        }
    }, [width, height]);

    return (<g ref={ref} width={width} height={height} >
        {links.map(link=>{
            var numOutputs = link.source.outputs || 1;
            var sourcePort = link.sourcePort || 0;
            var y = ((link.source.h/2)-(numOutputs/2)*13)+13*(sourcePort); //(numOutputs/2)*13 + 13*sourcePort; //((height/2)-(outputs/2)*13)+13*i
            var x1 = link.source.x+(link.source.w||0);
            var y1 = link.source.y+y+5;
            var x2 = link.target.x;
            var y2 = link.target.y+(link.target.h/2||0);
            return (<D3Line key={link.id} id={link.id}  origX={x1} origY={y1} destX={x2} destY={y2} sc={1} />);
        })}
        {new_link?<D3Line id={new_link.id} origX={new_link.source.x} origY={new_link.source.y} destX={new_link.target.x} destY={new_link.target.y} sc={new_link.dir} />:null}
    </g>);
});


export default LinkLayer;
